import { type ConflictType, type GetFindingsRequest } from '@consigli/types';

export type RfpFindingsConflictType = ConflictType.MILESTONE | ConflictType.DELIVERABLE;

/**
 * The findings request behind the RFP dashboard's timeline and requirements.
 *
 * RTK Query caches by the request's arguments, so anything that wants to read
 * the dashboard's cached milestones or deliverables builds them here: one field
 * more or less would be a separate cache entry and a second network call.
 */
export const rfpFindingsQuery = (
  projectId: GetFindingsRequest['projectId'],
  packageId: GetFindingsRequest['packageId'],
  conflictType: RfpFindingsConflictType,
): GetFindingsRequest => ({ projectId, packageId, page: 'all', conflictType });
